var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackBlackOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20736 15.0581C9.43409 15.0873 9.64578 15.1006 9.84373 15.1006C11.9043 15.1006 12.4751 13.6393 12.7026 13.0566C13.1456 11.9197 13.5138 9.86613 13.6523 9.07769C13.7993 8.20136 13.6039 7.40341 13.1028 6.8305C12.6448 6.30714 11.9594 6.00011 11.1721 6.00011H8.92367C8.92367 6.00011 9.12195 5.21538 9.27125 4.63385C9.76428 2.71328 8.66872 2.02488 7.10858 2.1071L4.83205 6.36288L2 7.95021V13.8005L9.20736 15.0581ZM10.8973 17.1798C10.6802 16.9316 10.5205 16.6412 10.4212 16.3205C11.55 16.2383 12.3646 15.7879 12.9308 15.2092C13.5139 14.6133 13.7797 13.9319 13.9014 13.62L13.9089 13.6006C14.3957 12.3514 14.7816 10.207 14.9251 9.38917L14.9275 9.38111L14.9374 9.322C14.9563 9.20953 14.9709 9.09724 14.9812 8.98511L22.0001 10.2097V16.0601L19.1681 17.6474L16.8915 21.9032C15.3313 21.9854 14.2358 21.297 14.7288 19.3764C14.8454 18.9212 14.9613 18.4657 15.0764 18.0101H12.828C12.0407 18.0101 11.3553 17.7031 10.8973 17.1798Z",
    stroke: "black",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackBlackOutline);
export default __webpack_public_path__ + "static/media/feedback-black-outline.c6ae79fe089ec885719c84016e2d7efc.svg";
export { ForwardRef as ReactComponent };